import React, { useState } from 'react';
import I18n from '@/modules/i18n';
import Popover from '@/components/ui/Popover';
import ConfirmDeleteModal from '@/components/common/Modal/ConfirmDeleteModal';
import useFlags from '@/hooks/useFlags';
import { ISlide } from '@/components/admin/SlideShow/stores/useSlideShowStore';
import { Button } from '@/components/ui/Buttons';
import Icon from '@/components/ui/Icon';
import styles from '../../SlideShowBuilder.module.scss';
import FramePicker from './FramePicker';
import useApplyFrame from './useApplyFrame';

interface FrameButtonProps {
  slide: ISlide;
}

const FrameButton = ({ slide }: FrameButtonProps) => {
  const { flushImageTreatment } = useFlags();
  const [isConfirmingRemove, setIsConfirmingRemove] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { applyFrame, isLoading } = useApplyFrame(slide);

  const confirmRemoveFrame = () => {
    setIsPopoverOpen(false);
    setIsConfirmingRemove(true);
  };

  if (!flushImageTreatment || !slide.displaySlideHeader) return null;

  const label = slide.slideFrameId ? I18n.t('edit_frame') : I18n.t('add_frame');

  return (
    <>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <Popover.Trigger asChild>
          <Button outlineStyle className="dropdown-toggle end">
            <div className={`mr10 ${styles.textWithIcon}`}>
              <Icon className="tw-mr-2" icon="Frame" size={16} />
              {label}
            </div>
          </Button>
        </Popover.Trigger>
        <Popover.Content side="top" width="unset">
          <FramePicker slide={slide} onRemoveFrame={confirmRemoveFrame} />
        </Popover.Content>
      </Popover>
      <ConfirmDeleteModal
        confirmationText={I18n.t('remove_frame_confirmation')}
        confirmButtonText={I18n.t('yes_remove')}
        headerText={I18n.t('remove_frame')}
        isLoading={isLoading}
        isOpen={isConfirmingRemove}
        onCancel={() => setIsConfirmingRemove(false)}
        onConfirm={() => applyFrame(null, () => setIsConfirmingRemove(false))}
      />
    </>
  );
};

export default FrameButton;
